import Base, {
  axios,
  setPromise,
  getEndpoint,
  omitId
} from './base'

export {
  APIURI,
  client_secret,
  client_id,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  endpoints,
  services,
  handlePromise,
  promise,
  setPromise,
  getEndpoint
} from './base'

const myServices = {}

export const create = myServices.create = async (payload, options = {}) => {
  const endPoint = getEndpoint('forms.create', {}, '/web-forms/create', options)
  const {data = {}} = await axios.post(endPoint, payload)
  return data
}
setPromise('forms.create', create)

export const read = myServices.read = async (payload, options = {}) => {
  const endPoint = getEndpoint('forms.read', payload, '/web-forms/get/{id}', options)
  const {data = {}} = await axios.get(endPoint, {params: omitId(payload)})
  return data
}
setPromise('forms.read', read)

export const ping = myServices.ping = async (payload, options = {}) => {
  const endPoint = getEndpoint('forms.ping', payload, '/web-forms/ping/{id}', options)
  const {data = {}} = await axios.get(endPoint, {params: omitId(payload)})
  return data
}
setPromise('forms.ping', read)

export const update = myServices.update = async (payload, options = {}) => {
  const endPoint = getEndpoint('forms.update', payload, '/web-forms/update/{id}', options)
  const {data = {}} = await axios.put(endPoint, omitId(payload))
  return data
}
setPromise('forms.update', update)

export const updateOrCreate = myServices.updateOrCreate = async (payload, options = {}) => {
  if (payload.id) {
    return await update(payload, options)
  } else {
    return await create(payload, options)
  }
}
setPromise('forms.updateOrCreate', updateOrCreate)

export const deleteForm = myServices.deleteForm = async (payload, options = {}) => {
  const endPoint = getEndpoint('forms.delete', payload, '/web-forms/delete/{id}', options)
  const {data = {}} = await axios.delete(endPoint)
  return data
}
setPromise('forms.delete', deleteForm)

export const archive = myServices.archive = async (payload, options = {}) => {
  const endPoint = getEndpoint('forms.archive', payload, '/web-forms/archive/{id}', options)
  const {data = {}} = await axios.post(endPoint, omitId(payload))
  return data
}
setPromise('forms.archive', archive)

export const restore = myServices.restore = async (payload, options = {}) => {
  const endPoint = getEndpoint('forms.restore', payload, '/web-forms/restore/{id}', options)
  const {data = {}} = await axios.get(endPoint, {params: omitId(payload)})
  return data
}
setPromise('forms.restore', restore)

export const submit = myServices.submit = async (payload, options = {}) => {
  const endPoint = getEndpoint('forms.submit', payload, '/web-forms/submit/{id}', options)
  const {data = {}} = await axios.post(endPoint, omitId(payload))
  return data
}
setPromise('forms.submit', submit)

export const importModule = myServices.importModule = async (payload, options = {}) => {
  const endPoint = getEndpoint('forms.importModule', payload, '/web-forms/import-module/{id}', options)
  const {data = {}} = await axios.get(endPoint, {params: omitId(payload)})
  return data
}
setPromise('forms.importModule', importModule)

export const contentFormStates = myServices.contentFormStates = async (payload, options = {}) => {
  const endPoint = getEndpoint('forms.contentFormStates', payload, '/web-forms/content-form-states', options)
  const {data = {}} = await axios.get(endPoint, {params: payload})
  return data
}
setPromise('forms.contentFormStates', contentFormStates)

export default {
  ...Base,
  ...myServices
}
